package com.github.jangalinski.tabweb.button

/**
 * Enumerates the supported Tabweb corner shapes for a [Button].
 */
enum class ButtonShape {
  DEFAULT,
  PILL,
  SQUARE,
}
